import { Theme } from '..';
import { colors } from './colors';
import { components } from './components';
import { fontFaces, fonts } from './fonts';
import { global } from './global';
import { buttonIcons, icons } from './icons';
import { layout } from './layout';

const theme: Theme = {
  name: 'RSA',
  fonts,
  fontFaces,
  icons,
  buttonIcons,
  layout,
  colors,
  components,
  gradients: {
    gradient01: {
      from: '#cb9ae3',
      to: colors.core01,
    },
  },
  externalOnlyRichTextOpenInNewTabIcon: 'new-tab',
  global,
  buttonRadius: '32px',
  cardRadius: '0',
  inputRadius: '0',
  tableRadius: '0',
};

export default theme;
